import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Every route change starts at the top, unless the URL targets a section anchor
// (e.g. /#booking), which the landing page handles itself.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
